/**
 * Remitente de los correos transaccionales de DAYSI (códigos OTP de la
 * verificación en 2 pasos, restablecer contraseña).
 *
 * Debe coincidir con el SMTP_FROM configurado en el .env.<projectId> de
 * daysi-cloud-functions (alias de Workspace desde el que salen los correos).
 * Se muestra al usuario para que sepa qué remitente buscar en su bandeja
 * (y en spam la primera vez).
 */
export const MAIL_SENDER = 'mail.service@crconsultorescolombia.com';
